import * as Actions from './user.actions';
import { UserState, UserAction } from './user.actions';
import * as RequestStates from '../../../../types/request-state.model';

const initialState: UserState = {

}

export default function User(state: UserState = initialState, action: UserAction) {
  switch (action.type) {
    case Actions.GET_CURRENT_USER:
      return Object.assign(
        {},
        state,
        action.payload
      );
    case Actions.GET_CURRENT_USER_IN_PROGRESS:
      return Object.assign(
        {},
        state,
        action.payload
      );
    case Actions.GET_CURRENT_USER_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getCurrentUserState: RequestStates.REQUEST_SUCCESS
        }
      );
    case Actions.GET_CURRENT_USER_FAIL:
      return Object.assign(
        {},
        state,
        action.payload,
        {
          getCurrentUserState: RequestStates.REQUEST_FAILED
        }
      );
    
    case Actions.GET_GROUPS_SUCCESS:
      return Object.assign(
        {},
        state,
        action.payload
      );

    case Actions.LOGIN:
      return Object.assign(
        {},
        state,
        action.payload
      );

    default:
      return state;
  }
}